import {
    Breadcrumb,
    Button,
    Col,
    Empty,
    Form,
    FormInstance,
    Input,
    Menu,
    Modal, Popconfirm,
    Row,
    Select,
    Space,
    Table,
    Tree,
    notification
} from "antd";
import React from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import { RootStoreModel } from "../../redux/reducers";
import {
    BasicStateForListModel
} from "../models";
//import { TemplateContent } from "./template.content"
import { CheckCircleFilled, PlusOutlined, StopFilled } from '@ant-design/icons';
import {
    addManager, deleteManager,
    deleteRoleByID,
    getAccountList,
    getMenuList,
    getRoles,
    getRolesList,
    postRoles,
    registerManager,
    resetPwdByManager
} from "../../axios/api.account";
import { gaEvent } from "../../withTracker";

import i18n from "@src/locales";
import { DataNode } from "antd/lib/tree";
import copy from "copy-to-clipboard";
import { Translation } from "react-i18next";
import TextArea from "antd/lib/input/TextArea";
const { Column } = Table;
const { SubMenu } = Menu;
const { Item, List } = Form;
interface stateModel extends BasicStateForListModel {
    name: string,
    current: string,
    selectTemplate: string,
    isShowAddForm: boolean,
    isShowInvite: boolean,
    loding: boolean,
    search: string,
    isUpdate: boolean,
    inviteMethod: string,
    manageType: string,
    showModalRole: boolean,
    isAddRole: boolean,
    menuList: any[],
    selectRoleId: string,
    scopeMap: any,
    roleList: any[],
    isShowResetPwd : boolean,
    checkedKeys: React.Key[],
    expandedKeys: React.Key[],
    halfCheckedKeys: React.Key[],
    autoExpandParent: boolean,
    treeData : any[]
}
interface propsModel extends RouteComponentProps<any, any, any> {
}
const mapStatetoProps = (state: RootStoreModel) => ({

});
interface ManagerInfo {
    name: string,
    role: string,
    account: string
}
class ManagerIndex extends React.Component<propsModel, stateModel> {
    formRef = React.createRef<FormInstance>();
    formRefRole = React.createRef<FormInstance>();
    formResetRef = React.createRef<FormInstance>();
    constructor(props: propsModel) {
        super(props);
        this.state = {
            name: "TemplateIndex",
            current: "password",
            selectTemplate: "1",
            isShowAddForm: false,
            isShowInvite: false,
            pageIndex: 1,
            pageSize: 20,
            totalCount: 0,
            search: "",
            loading: false,
            data: [],
            columns: [],
            loding: false,
            isUpdate: false,
            inviteMethod: "url",
            manageType: "auth",
            showModalRole: false,
            isAddRole: false,
            menuList: [],
            selectRoleId: "",
            scopeMap: {
                0: "无",
                1: "只读",
                10: "编辑"
            },
            roleList: [],
            isShowResetPwd : false,
            checkedKeys:[],
            expandedKeys: [],
            halfCheckedKeys:[],
            autoExpandParent: true,
            treeData:[]
        }
        this.Init();
    }


    Init() {
        this.getList();
    }

    formatData = (treeList: any[]): DataNode[] => {
        return treeList.map((tree) => {
          const { id, name, level, sort, childModules } = tree;
          const children = this.formatData(childModules);
          return {
            title: <Translation>{t => {return t(name)}}</Translation>,
            key: id,
            value: id,
            children: children,
          };
        });
    };

    formOK = () => {        
        if (this.state.isShowInvite) {
            if (this.state.inviteMethod === "url") {
                this.setState({isShowInvite: false, loading: false});
            } else {
                this.formRef.current?.validateFields().then((res) => {
                    this.setState({ loading: true });
                    registerManager({reveiveEmails: res.email}).then(
                        () => {
                            this.getList();
                            this.setState({isShowInvite: false, loading: false, inviteMethod: "url"});
                            this.formRef.current?.resetFields();
                            notification.success({ message: <Translation>{t => {return t("邮件已发出,请注意查收!")}}</Translation> });
                        },
                        () => {
                            notification.success({ message: <Translation>{t => {return t("邮件发送失败,请检查邮箱是否正确!")}}</Translation> });
                        }
                    ).finally(() => {
                        this.setState({ loading: false });
                    })
                })
            }
        } else {
            this.formRef.current?.validateFields().then((res) => {
                this.setState({ loading: true });
                addManager(res).then(
                    c => {
                        this.getList();
                        this.setState({ loading: false, isShowAddForm: false })
                        this.formRef.current?.resetFields();
                        if (this.state.isUpdate) {
                            notification.success({ message: <Translation>{t => {return t("修改成功")}}</Translation> });
                        } else {
                            notification.success({ message: <Translation>{t => {return t("添加成功")}}</Translation> });
                        }
    
                    }, 
                    () => {
                        this.setState({ loading: false })
                    }
                )
            })
        }
    }

    onOK = () => {
        this.formRefRole.current?.validateFields(['name']).then(res => {
            var description = this.formRefRole.current?.getFieldValue('description');
            let param = {
                "roleId": this.state.selectRoleId,
                "name": res.name,
                "description":description,
                "checkedModuleIds": this.state.checkedKeys,
                "halfCheckedModuleIds": this.state.halfCheckedKeys
                // "moduleOptions": Object.keys(res).filter(key => key!== "name").map(key => {
                //     if (key !== "name") {
                //         let value = res[key];
                //         if (!value) {
                //             if (value !== 0) {
                //                 value = 10;
                //             }
                //         }
                //         return {
                //             key: key,
                //             option: value
                //         }
                //     }
                // })
            }
            console.log("param",param);
            postRoles(param).then(() => {
                this.setState({
                    showModalRole: false, 
                    isAddRole: false,
                    loading: false
                });
                this.formRefRole.current?.resetFields();
                this.getList("role");
                notification.success({message: <Translation>{t => {return t("添加成功")}}</Translation>})
            })
        })
    }

    onResetOK = () => {
        this.formResetRef.current?.validateFields().then(res => {
            console.log(res)
            resetPwdByManager({account :res.account, email:res.email, Password: res.password }).then(() => {
                this.setState({
                    isShowResetPwd: false, 
                    loading: false
                });
                this.formResetRef.current?.resetFields();
                notification.success({message: <Translation>{t => {return t("重置成功")}}</Translation>})
            })
        })
    }

    getList(type = this.state.manageType) {
        if (type === "auth") {
            Promise.all([
                getAccountList({search: this.state.search}), getRolesList()
            ]).then(([res1, res2]) => {
                this.setState({data: res1});
                let roles: any = res2.map((item: any) => {
                    return {
                        label: <Translation>{t => {return t(item.name)}}</Translation>,
                        value: item.roleId
                    }
                })
                this.setState({roleList: roles});
            })
            getAccountList({search: this.state.search}).then((res) => {
            })
        } else {
            Promise.all([
                getRoles({
                    search: this.state.search,
                    pageIndex: this.state.pageIndex,
                    pageSize: this.state.pageSize
                }),
                getMenuList()
            ]).then(([res1, res2]) => {
                res2 = res2.map(item => {
                    item["option"] = 10;
                    return item
                })
                this.setState({
                    data: res1.dataList,
                    pageIndex: res1.pageIndex,
                    pageSize: res1.pageSize,
                    totalCount: res1.totalCount,
                    menuList: res2
                })
            })
        }
    }

    handleMenuClick = (e: any) => {
        this.setState({ current: e.key });
    };

    onSearch = () => {
        this.getList();
    }

    componentDidMount() {
        console.log("componentDidMount");
    }
    deleteManager = (id: string) => {
        deleteManager(id).then(c => {
            notification.success({ message: <Translation>{t => {return t("删除成功")}}</Translation> });
            this.getList();
        })
    }
    updateManager = (row: any) => {
        this.formRef.current?.setFieldsValue(row);
        this.setState({ isShowAddForm: true, isUpdate: true })
    }
    resetPwd = (row: any) => {
        this.formResetRef.current?.setFieldsValue(row);
        this.setState({ isShowResetPwd: true });
    }

    addItems = (key: string) => {
        switch (key) {
            case "add":
                this.setState({ isShowAddForm: true, isUpdate: false });
                this.formRef.current?.resetFields(); 
                //gaEvent("manager", "onClick", "添加管理员")
                break;
            case "register":
                this.setState({ isShowInvite: true });
                //gaEvent("manager", "onClick", "邀请注册")
                break;
        
            default:
                break;
        }
    }

    addRole = () => {
        this.setState({
            showModalRole: true, 
            isAddRole: true,
            selectRoleId: "",
            treeData: this.formatData(this.state.menuList),
            checkedKeys:[]
        });
    }

    editRole = (row: any) => {
        let form: any = {}
        // row.modules.forEach((element: any) => {
        //     form[element.key] = element.option;
        // });
        form["name"] = row.name;
        form["description"] = row.description;
        this.formRefRole.current?.setFieldsValue(form);
        this.setState({
            showModalRole: true, 
            isAddRole: false,
            selectRoleId: row.roleId,
            treeData: this.formatData(row.modules),
            checkedKeys:row.checkedModuleIds,
            halfCheckedKeys: row.halfCheckedModuleIds
        });
    }

    deleteRole = (id: string) => {
        deleteRoleByID(id).then(() => {
            this.getList("role");
            notification.success({message: <Translation>{t => {return t("删除成功")}}</Translation>});
        })
    }

    checkoutManage = (e: any) => {
        this.setState({manageType: e.key});
        this.getList(e.key);
    }

    onExpand = (expandedKeysValue: React.Key[]) => {
        this.setState({
            expandedKeys: expandedKeysValue,
            autoExpandParent: false
        });
    };

    onCheck = (checkedKeys:any,event:any) => {
        console.log('onCheck', checkedKeys, event.halfCheckedKeys);
        this.setState({
            checkedKeys: checkedKeys,
            halfCheckedKeys: event.halfCheckedKeys
        });
    };

    render() {
        const { 
            data, search, loading, isShowAddForm, isUpdate, inviteMethod, isShowInvite, 
            manageType, showModalRole, isAddRole, menuList, scopeMap, roleList, isShowResetPwd
        } = this.state;
        return (
            (<Translation>{t => {
                    return (<>
                        <div>
                            <h5 className="breadcrumbTop py-2">
                                <Breadcrumb>
                                    <Breadcrumb.Item>{t("设置")}</Breadcrumb.Item>
                                    <Breadcrumb.Item>{t("授权管理")}</Breadcrumb.Item>
                                    <Breadcrumb.Item>{t("授权")}</Breadcrumb.Item>
                                </Breadcrumb>
                                <Row style={{padding: "32px 0 11px 0"}}>
                                    <Space>
                                        <img src="/images/adminsettingIcon.svg" alt="" />
                                        <span style={{display: "flex", fontSize: 22, fontWeight: 500, marginTop: -5}}>{t("授权")}</span>
                                    </Space>
                                </Row>
                                <Row>
                                    <Menu 
                                        selectedKeys={[manageType]}
                                        onClick={this.checkoutManage}
                                        mode="horizontal" 
                                        style={{borderBottom: 0, marginLeft: -20, width: "100%"}}
                                    >
                                        <Menu.Item key="auth">{t("授权管理")}</Menu.Item>
                                        <Menu.Item key="role">{t("角色管理")}</Menu.Item>
                                    </Menu>
                                </Row>
                            </h5>
                            <Row style={{ width: "100%" }}>
                                <div className="borderBox">
                                    <Row className="mb-3" gutter={16}>
                                        <Col>
                                            <Space>
                                                <span>{manageType === "auth" ? t("登录账号") : t("角色")}:</span>
                                                <Input
                                                    placeholder={manageType === "auth" ? t("输入登录账号搜索") : t("输入角色搜索")}
                                                    value={search} 
                                                    onChange={(e) => this.setState({ search: e.target.value })} 
                                                />
                                            </Space>
                                        </Col>
                                        <Col>
                                            <Button type="primary" onClick={() => { this.onSearch(); gaEvent("user", "onClick", "onSearch") }}>
                                                {t("查询")}
                                            </Button>
                                        </Col>
                                    </Row>

                                </div>
                                <div className="borderBox">
                                    <Row>
                                        <Row style={{ width: "100%", marginBottom: 8 }}>
                                            <Col className="ms-auto">
                                                {manageType === "auth" && (<>
                                                    {/* <Dropdown dropdownRender={() => (
                                                        <Menu onClick={(e) => { this.addItems(e.key) }}>
                                                            <Menu.Item key="add">{t("添加管理员")}</Menu.Item>
                                                            <Menu.Item key="register">{t("邀请注册")}</Menu.Item>
                                                        </Menu>
                                                    )}>
                                                        <Button type="primary" style={{width: "100px"}}><PlusOutlined />{t("添加")}</Button>
                                                    </Dropdown> */}
                                                    <Button type="primary" style={{width: "150px"}} onClick={() => { this.addItems("add") }}><PlusOutlined />{t("添加管理员")}</Button>
                                                </>)}
                                                {manageType === "role" && (<>
                                                    <Button type="primary" style={{width: "100px"}} onClick={() => { this.addRole() }}><PlusOutlined />{t("添加")}</Button>
                                                </>)}
                                            </Col>
                                        </Row>
                                        {manageType === "auth" && (<>
                                            <Table 
                                                size="middle" 
                                                dataSource={data} 
                                                style={{ width: "100%" }} 
                                                pagination={false}
                                                locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                                            >
                                                <Column
                                                    key="key"
                                                    dataIndex="key"
                                                    title={t("序号")}
                                                    render={(v, d, i) => i + 1}
                                                ></Column>
                                                <Column
                                                    title={t("账号类型")}
                                                    key="accountType"
                                                    dataIndex="accountType"
                                                ></Column>
                                                <Column
                                                    title={t("登录账号")}
                                                    key="email"
                                                    dataIndex="email"
                                                ></Column>
                                                <Column 
                                                    title={t("角色")} 
                                                    key="role" 
                                                    dataIndex="role"
                                                    render={(v) => {
                                                        if (v === "SuperAdmin") {
                                                            return t(v)
                                                        } else {
                                                            return roleList.filter(item => item.value === v)[0]?.label;
                                                        }
                                                    }}
                                                ></Column>
                                                <Column
                                                    title={t("状态")}
                                                    key="status"
                                                    dataIndex="status"
                                                    render={(v) => (
                                                        <> 
                                                            {v=="Active"&&(
                                                                <span ><CheckCircleFilled  style={{color:"#4CB8BE",fontSize:16}}/>&nbsp;&nbsp;{v}</span>
                                                            )}
                                                            {v=="Disabled"&&(
                                                                <span><StopFilled  style={{color:"#C9A063",fontSize:16}}/>&nbsp;&nbsp;{v}</span>
                                                            )}
                                                        </>
                                                    )}
                                                ></Column>
                                                <Column
                                                    title={t("操作")}
                                                    key="id"
                                                    dataIndex="id"
                                                    render={(v, row: any, index) => {
                                                        return (
                                                            <Space size={8}>
                                                                <Button disabled={row?.role == "SuperAdmin" || row?.isOwner}
                                                                    onClick={() => { this.resetPwd(row); }} type="link" block>{t("重置密码")}</Button>
                                                                <Button disabled={row?.role == "SuperAdmin" || row?.isOwner}
                                                                    onClick={() => { this.updateManager(row); gaEvent("manager", "onClick", "updateManager") }} type="link" block>{t("编辑")}</Button>
                                                                <Button disabled={row?.role == "SuperAdmin" || row?.isOwner}
                                                                    onClick={() => { this.deleteManager(row.account); gaEvent("manager", "onClick", "deleteManager") }} type="link" block>{t("删除")}</Button>
                                                            </Space>
                                                        )
                                                    }}></Column>
                                            </Table>
                                        </>)}
                                        {manageType === "role" && (<>
                                            <Table 
                                                size="middle" 
                                                dataSource={data} 
                                                style={{ width: "100%" }} 
                                                pagination={false}
                                                locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                                            >
                                                <Column
                                                    key="key"
                                                    dataIndex="key"
                                                    title={t("序号")}
                                                    width={"10%"}
                                                    render={(v, d, i) => i + 1}
                                                ></Column>
                                                <Column
                                                    title={t("角色")}
                                                    key="name"
                                                    dataIndex="name"
                                                    render={(v) => {
                                                        return t(v)
                                                    }}
                                                    width={"20%"}
                                                ></Column>
                                                <Column
                                                    title={t("描述")}
                                                    key="description"
                                                    dataIndex="description"
                                                    width={"20%"}
                                                ></Column>
                                                {/* <Column
                                                    title={t("功能范围")}
                                                    key="modules"
                                                    dataIndex="modules"
                                                    ellipsis
                                                    width={"50%"}
                                                    render={(v) => {
                                                        let value = v?.map((item: any) => {
                                                            return `${t(item.name)}-${t(scopeMap[item.option])}`
                                                        })
                                                        return value?.join("，")
                                                    }}
                                                ></Column> */}
                                                <Column
                                                    title={t("操作")}
                                                    key="roleId"
                                                    dataIndex="roleId"
                                                    width={"20%"}
                                                    render={(v, row: any, index) => {
                                                        return (
                                                            <Space size={8}>
                                                                <Button onClick={() => { this.editRole(row) }} type="link" block>{t("编辑")}</Button>
                                                                <Popconfirm
                                                                    title={`${t("确认删除")}？`}
                                                                    onConfirm={() => { this.deleteRole(v) }}
                                                                    okText={t("确认")}
                                                                    cancelText={t("取消")}
                                                                >
                                                                    <Button type="link" block>{t("删除")}</Button>
                                                                </Popconfirm>
                                                            </Space>
                                                        )
                                                    }}></Column>
                                            </Table>
                                        </>)}
                                    </Row>
                                </div>
                            </Row>
                        </div>
                        <Modal
                            confirmLoading={loading}
                            maskClosable={false}
                            open={isShowAddForm}
                            destroyOnClose={true}
                            title={this.state.isUpdate ? t("修改管理员") : t("添加管理员")}
                            forceRender={true}
                            width={"650px"}
                            onOk={() => { this.formOK() }}
                            onCancel={() => {
                                this.setState({ isShowAddForm: false });
                                this.formRef.current?.resetFields();
                            }}
                            okText={t("确认")}
                            cancelText={t("取消")}
                        >
                            <Form
                                labelCol={{ span: 6 }}
                                ref={this.formRef}
                                layout="vertical"
                                initialValues={{ accountType: "Email", account: "", email: "", role: "", status: "Active" }}
                            >
                                {/* <Item label={t("账号类型")} name="accountType" rules={[{ required: true }]}>
                                    <Select disabled={isUpdate}>
                                        <Select.Option value="AAD" >AAD</Select.Option>
                                        <Select.Option value="Email" >Email</Select.Option>
                                    </Select>
                                </Item> */}
                                <Item style={{display:"none"}} name="account"></Item>
                                <Item label={t("登录邮箱")} name="email" rules={[{ required: true }]}>
                                    <Input disabled={isUpdate} />
                                </Item>
                                {!isUpdate &&
                                <Item label={t("初始密码")} name="password" rules={[
                                    { 
                                        required: true 
                                    },
                                    {
                                        // pattern: new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*]).{8,}$'),
                                        pattern: new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[~`·!@#$%^&*()<>?,.:;_+/、，。：；？！（）【】《》-]).{8,}$'),
                                        message: '密码必须包含大小写字母和特殊字符，且长度至少为8',
                                        //message: 'Password must contain at least one lowercase, one uppercase, and one special character, and be at least 8 characters long.',
                                    }]}>
                                    <Input.Password />
                                </Item>
                                }
                                <Item label={t("角色")} name="role" rules={[{ required: true }]}>
                                    <Select options={roleList} />
                                    {/* <Select>
                                        <Select.Option value="CoAdmin">CoAdmin</Select.Option>
                                        <Select.Option value="Reader">Reader</Select.Option>
                                        <Select.Option value="Contributor">Contributor</Select.Option>
                                    </Select> */}
                                </Item>
                                <Item label={t("状态")} name="status" rules={[{ required: true }]}>
                                    <Select>
                                        <Select.Option value="Active">Active</Select.Option>
                                        <Select.Option value="Disabled">Disabled</Select.Option>
                                    </Select>
                                </Item>

                            </Form>
                        </Modal>
                        <Modal
                            confirmLoading={loading}
                            maskClosable={false}
                            open={showModalRole}
                            destroyOnClose={true}
                            title={isAddRole ? t("添加角色") : t("编辑角色")}
                            forceRender={true}
                            width={i18n.language === 'zh' ? "600px" : "650px"}
                            onOk={() => { this.onOK() }}
                            onCancel={() => {
                                this.setState({ showModalRole: false, isAddRole: false });
                                this.formRefRole.current?.resetFields();
                            }}
                            okText={t("确认")}
                            cancelText={t("取消")}
                        >
                            <Form
                                labelCol={{ span: i18n.language === 'zh' ? 6 : 8 }}
                                wrapperCol={{ span: 14 }}
                                ref={this.formRefRole}
                            >
                                <Item label={t("角色名称")} name="name" rules={[{ required: true }]} labelCol={{span: 6}}>
                                    <Input />
                                </Item>
                                <Item label={t("描述")} name="description" labelCol={{span: 6}}>
                                    <TextArea rows={4} />
                                </Item>
                                {/* <div style={{display: "flex", flexDirection: "column"}}> */}
                                    {/* {menuList.map((item: any, index) => {
                                        if ((index + 1) % 2 === 1) {
                                            return (<>
                                                <div style={{display: "flex"}}>
                                                    <Item label={t(item.name)} name={item.key} style={{width: "50%"}}>
                                                        <Radio.Group defaultValue={item.option} name={item.key}>
                                                            <Radio value={10}>{t("编辑")}</Radio>
                                                            <Radio value={1}>{t("只读")}</Radio>
                                                            <Radio value={0}>{t("无")}</Radio>
                                                        </Radio.Group>
                                                    </Item>
                                                    {index + 1 < menuList.length && (<>
                                                    <Item label={t(menuList[index+1]?.name)} name={menuList[index+1]?.key} style={{width: "50%"}}>
                                                        <Radio.Group defaultValue={menuList[index+1]?.option} name={menuList[index+1]?.key}>
                                                            <Radio value={10}>{t("编辑")}</Radio>
                                                            <Radio value={1}>{t("只读")}</Radio>
                                                            <Radio value={0}>{t("无")}</Radio>
                                                        </Radio.Group>
                                                    </Item>
                                                    </>)}
                                                </div>
                                            </>)
                                        }
                                    })} */}
                                    <Item label={t("选择菜单")} name="menu" rules={[{ required: true }]} labelCol={{span: 6}}>
                                    {this.state.treeData.length > 0 && <Tree
                                        checkable
                                        defaultExpandAll={true}
                                        blockNode={false}
                                        // checkStrictly
                                        //defaultCheckedKeys={['fd74b0df-0c74-11ef-995e-00163e2080ec','fd806a62-0c74-11ef-995e-00163e2080ec']}
                                        selectable={false}
                                        height={440}
                                        //onExpand={this.onExpand}
                                        //expandedKeys={this.state.expandedKeys}
                                        autoExpandParent={this.state.autoExpandParent}
                                        onCheck={this.onCheck}
                                        checkedKeys={this.state.checkedKeys}
                                        //onSelect={this.onSelect}
                                        //selectedKeys={this.state.selectedKeys}
                                        treeData={this.state.treeData}
                                    />}
                                    </Item>
                                {/* </div> */}

                            </Form>
                        </Modal>
                        <Modal
                            confirmLoading={loading}
                            maskClosable={false}
                            open={isShowInvite}
                            destroyOnClose={true}
                            title={t("邀请注册")}
                            width={"650px"}
                            onOk={() => { this.formOK() }}
                            onCancel={() => { 
                                this.setState({ isShowInvite: false, loading: false, inviteMethod: "url" });
                                this.formRef.current?.resetFields();
                            }}
                            okText={t("确认")}
                            cancelText={t("取消")}
                        >
                            <Form
                                labelCol={{ span: 6 }}
                                layout="vertical"
                                ref={this.formRef}
                                initialValues={{inviteMethod: "url"}}
                            >
                                <Item label={t("邀请方式")} name="inviteMethod">
                                    <Select onChange={(value: string) => this.setState({inviteMethod: value})}>
                                        <Select.Option value="url">{t("复制链接")}</Select.Option>
                                        <Select.Option value="email">{t("邮件")}</Select.Option>
                                    </Select>
                                </Item>

                                {this.state.inviteMethod === "url" && <>
                                    <p style={{textAlign: "center"}}>
                                        <a style={{color: "#1890FF", cursor: "pointer"}} onClick={() => {
                                            copy("https://bcrdsso.21vbluecloud.com/account/register")
                                            notification.success({message: t("已成功拷贝到剪贴板")})
                                        }}>{t("点击这里")} </a>
                                        <span>{t("复制链接后发送给需要邀请的用户")}</span>
                                    </p>
                                </>}

                                {this.state.inviteMethod === "email" && <>
                                    <Item label={t("邮箱")} name="email" rules={[{required: this.state.inviteMethod === "email", type: "email"}]}>
                                        <Input />
                                    </Item>
                                </>}
                            </Form>
                        </Modal>
                        <Modal
                            confirmLoading={loading}
                            maskClosable={false}
                            open={isShowResetPwd}
                            destroyOnClose={true}
                            title={t("重置密码")}
                            forceRender={true}
                            width={"650px"}
                            onOk={() => { this.onResetOK() }}
                            onCancel={() => {
                                this.setState({ isShowResetPwd: false });
                                this.formResetRef.current?.resetFields();
                            }}
                            okText={t("确认")}
                            cancelText={t("取消")}
                        >
                            <Form
                                labelCol={{ span: 6 }}
                                ref={this.formResetRef}
                                layout="vertical"
                            >
                                <Item style={{display:"none"}} name="account"></Item>
                                <Item label={t("登录邮箱")} name="email" rules={[{ required: true }]}>
                                    <Input disabled={true} />
                                </Item>
                                <Item label={t("密码")} name="password" rules={[
                                    { 
                                        required: true 
                                    },
                                    {
                                        pattern: new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[~`·!@#$%^&*()<>?,.:;_+/、，。：；？！（）【】《》-]).{8,}$'),
                                        message: '密码必须包含大小写字母和特殊字符，且长度至少为8',
                                        //message: 'Password must contain at least one lowercase, one uppercase, and one special character, and be at least 8 characters long.',
                                    }]}>
                                    <Input.Password />
                                </Item>
                                <Form.Item
                                    name="confirm"
                                    label={t("密码确认")}
                                    dependencies={['password']}
                                    hasFeedback
                                    rules={[
                                        {
                                        required: true,
                                        message: 'Please confirm your password!',
                                        },
                                        ({ getFieldValue }) => ({
                                        validator(_, value) {
                                            if (!value || getFieldValue('password') === value) {
                                            return Promise.resolve();
                                            }
                                            return Promise.reject(new Error('The two passwords that you entered do not match!'));
                                        },
                                        }),
                                    ]}
                                    >
                                    <Input.Password />
                                    </Form.Item>
                            </Form>
                        </Modal>
                    </>);
                }}</Translation>)
        );
    }
}

export default connect(mapStatetoProps, {})(ManagerIndex);